import type { BundleSelectsStates } from "~/components/ui/Product/ProductHeader/_data/serialize-bundle-selector"
import { objectKeys } from "~/utils/object-keys"

export function remapDefaultValuesFromURLOptions(optionsFromURL: string[], defaultOptions: BundleSelectsStates) {
  return (
    optionsFromURL?.reduce((acc, option, index) => {
      const currentDefaultOptionKey = objectKeys(defaultOptions)[index]

      if (currentDefaultOptionKey && option) {
        acc[currentDefaultOptionKey] = option
      }

      return acc
    }, {} as BundleSelectsStates) ?? defaultOptions
  )
}
